import Vue from 'vue'
import Page from '@/components/pdf-pages/exchange-agreement'
import injectedCss from '!!raw-loader!@/components/pdf-pages/css/exchange-agreement.css'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateExchangeAgreement = async ({ rfq3, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :content="content" :rfq3="rfq3" />`,
      components: {
        'page': Page
      },
      data: () => ({
        content,
        rfq3
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss, injectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
